var exports = {
  "p_": "list__3qIFpI",
  "nM": "row__cTj2Bs",
  "DT": "removeButton__mj9vMI",
  "Nr": "card__LQmUuG",
  "wx": "header__V0Si5g",
  "L$": "toggle__BIqcvs",
  "xo": "headerExpanded__A3mllh",
  "nL": "toggleOpen__xZJoy7",
  "Ae": "path__GgksVO",
  "LF": "pathText__2qHnok",
  "rf": "body__rDwh19",
  "cy": "author__Dln-aT",
  "Pl": "iconAvatar__PdTld1",
  "fh": "authorName__aSxbbg",
  "ah": "authorLink__ymmzu_",
  "cp": "avatarLink__mQGnTw",
  "vE": "timestamp__5iUy9I",
  "G3": "bodyText__XcKRR5",
  "Gn": "suggestions__VldjFl",
  "gF": "suggestionsLabel__PbgpdP",
  "SQ": "suggestionFiles__4cGk9y",
  "d3": "rowOutdated__OBu6D-",
};

module.exports = exports;
